var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.899,25.091C19.578,24.237,20,23.172,20,22c0-2.757-2.243-5-5-5s-5,2.243-5,5c0,1.172,0.422,2.237,1.101,3.091 C8.773,25.517,7,27.551,7,30v7h16v-7C23,27.551,21.227,25.517,18.899,25.091z M15,19c1.654,0,3,1.346,3,3s-1.346,3-3,3 s-3-1.346-3-3S13.346,19,15,19z M21,35H9v-5c0-1.654,1.346-3,3-3h6c1.654,0,3,1.346,3,3V35z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 20,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 20,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 25,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 25,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 30,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 30,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 35,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 35,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 35,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 35,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,4h-8v6H1v36h48V10H29V4z M23,6h4v4v4h-4v-4V6z M47,12v32H3V12h18v4h8v-4H47z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.b31e3e411b7c1a9212a7bf05860e5f7f.svg";
export { ForwardRef as ReactComponent };